import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface IStoreState {
  storeSeq: string; // 암호화된 번호
  storeSeqNumber: number; // 숫자번호 (임시)
  storeName: string;
  isBN: boolean; // 사업장 인증 여부
}
export interface IStore extends IStoreState {
  setStoreInfo: (data: IStoreState) => void;
}

const useStoreStore = create<IStore>()(
  persist(
    (set, get) => ({
      storeSeq: '',
      storeName: '',
      storeSeqNumber: 0,
      isBN: false,
      setStoreInfo: (data: IStoreState) =>
        set((state) => ({
          storeSeq: data?.storeSeq ?? '',
          storeName: data.storeName,
          storeSeqNumber: data.storeSeqNumber,
          isBN: data.isBN,
        })),
    }),
    {
      name: 'store-storage',
      onRehydrateStorage: (state) => {
        return (state, error) => {
          if (error) {
          } else {
          }
        };
      },
    },
  ),
);

export default useStoreStore;
